import React from 'react';
import {
    LayoutDashboard, Users, UserPlus, FileText, Activity, Server,
    Clock, Mail, BarChart3, TrendingUp, GitBranch, Newspaper,
    BookOpen, PenTool, LineChart, Inbox, Bug, Database
} from 'lucide-react';

const iconMap = {
    LayoutDashboard, Users, UserPlus, FileText, Activity, Server,
    Clock, Mail, BarChart3, TrendingUp, GitBranch, Newspaper,
    BookOpen, PenTool, LineChart, Inbox, Bug, Database
};

const navItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.75rem 1.25rem',
    fontSize: '0.875rem',
    color: 'var(--text-secondary, #64748b)',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderLeft: '3px solid transparent'
};

const navItemActiveStyle = {
    ...navItemStyle,
    color: 'var(--accent-slate, #5b7c8d)',
    background: 'var(--bg-card, #ffffff)',
    borderLeftColor: 'var(--accent-slate, #5b7c8d)',
    fontWeight: '600'
};

const navItemHoverStyle = {
    background: 'rgba(91, 124, 141, 0.05)'
};

const sectionLabelStyle = {
    padding: '1rem 1.25rem 0.5rem',
    fontSize: '0.7rem',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: 'var(--text-secondary, #64748b)',
    opacity: 0.7
};

const AdminSidebar = ({ sections, activeSection, onSectionChange }) => {
    const [hoveredItem, setHoveredItem] = React.useState(null);

    let lastGroup = null;

    return (
        <nav style={{ padding: '0.5rem 0' }}>
            {sections.map(section => {
                const Icon = iconMap[section.icon];
                const isActive = activeSection === section.id;
                const isHovered = hoveredItem === section.id;

                const showGroupLabel = section.group && section.group !== lastGroup;
                lastGroup = section.group;

                return (
                    <React.Fragment key={section.id}>
                        {showGroupLabel && (
                            <div style={sectionLabelStyle}>{section.group}</div>
                        )}
                        <div
                            style={{
                                ...(isActive ? navItemActiveStyle : navItemStyle),
                                ...(isHovered && !isActive ? navItemHoverStyle : {})
                            }}
                            onClick={() => onSectionChange(section.id)}
                            onMouseEnter={() => setHoveredItem(section.id)}
                            onMouseLeave={() => setHoveredItem(null)}
                        >
                            {Icon && <Icon size={16} />}
                            <span>{section.label}</span>
                        </div>
                    </React.Fragment>
                );
            })}
        </nav>
    );
};

export default AdminSidebar;
